module.exports = __webpack_public_path__ + "img/client10.a045da1d.webp";